module.exports = __webpack_public_path__ + "img/bttn-pause.110227bb.svg";